import AtcFlightFareModule from './flight-fare/flight-fare-module';
import AtcFlightSegmentModule from './flight-segment/flight-segment-module';

import AtcFlightRecommendation from './flight-recommendation-component';
import AtcFlightRecommendationService from './flight-recommendation-service';

const MODULE_NAME = 'app.atc.flight.recommendation';
const module = angular.module(MODULE_NAME, [
        AtcFlightSegmentModule,
        AtcFlightFareModule,
    ])
    .directive(AtcFlightRecommendation.DIRECTIVE_NAME, AtcFlightRecommendation)
    .service('atcFlightRecommendationService', AtcFlightRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-recommendation-module.js